import React from 'react';
import DefaultView from '../View';
import LoadingIndicator from '@au/core/lib/components/elements/LoadingIndicator';
import {get} from '../../../utils/api';
import { formatMessage } from '../../../utils/reactIntl';

export default class GroupView extends DefaultView {

  constructor(props) {
    super(props);

    // must be set in the contructor so DefaultView state is not overwritten
    this.state = {
      ...this.state,
      vehicleCount: null,
      deviceCount: null,
      fetchingMemberCount: false, // Will be set to true when fetching starts
      memberCountError: false,
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  loadData = async () => {
    try {
      await super.loadData();
      await this.fetchMemberCount();
    } catch (error) {
      /* eslint-disable no-console */
      console.error('Error in GroupView loadData (main entity or member count fetch):', error);
      /* eslint-enable no-console */
      // ensure the component is marked as ready even if there's an error in custom fetching
      if (!this.state.ready) {
        this.setState({ ready: true });
      }
    } finally {
      // ensure ready state is set even if member count fetch fails, so the view renders
      if (!this.state.ready) {
          this.setState({ ready: true });
      }
    }
  }

  fetchMemberCount = async () => {
    this.setState({ fetchingMemberCount: true, memberCountError: false });
    try {
      const groupId = this.entityId;
      const response = await get(`/v1/inventory/groups/${groupId}/countGroupMembers`);
      const { totalCount, countByMemberType } = response.data;

      // If totalCount is 0, set both counts to 0
      if (totalCount === 0) {
        this.setState({
          vehicleCount: 0,
          deviceCount: 0,
          fetchingMemberCount: false,
        });
      } else {
        // Get vehicle count
        const vehicleCount = countByMemberType['assets/vehicle'] || 0;

        // Sum all device counts (anything starting with "assets/devices")
        const deviceCount = Object.keys(countByMemberType)
            .filter(key => key.startsWith('assets/devices'))
            .reduce((sum, key) => sum + countByMemberType[key], 0);

        this.setState({
          vehicleCount,
          deviceCount,
          fetchingMemberCount: false,
        });
      }
    } catch (error) {
      /* eslint-disable no-console */
      console.error('Error fetching group member count:', error);
      /* eslint-enable no-console */
      this.setState({
        vehicleCount: 0,
        deviceCount: 0,
        fetchingMemberCount: false,
        memberCountError: true,
      });
    }
  }

  renderTableRows(customAttributes) {
    let rows = super.renderTableRows(customAttributes);

    const { vehicleCount, deviceCount, fetchingMemberCount, memberCountError } = this.state;

    // create vehicle member count row
    let vehicleCountValue;
    if (fetchingMemberCount) {
      vehicleCountValue = <LoadingIndicator display={true} />;
    } else if (memberCountError) {
      vehicleCountValue = formatMessage({ id: 'au.entity.group.memberCount.error' });
    } else if (vehicleCount !== null) {
      vehicleCountValue = vehicleCount.toLocaleString();
    } else {
      vehicleCountValue = formatMessage({ id: 'au.entity.group.memberCount.unavailable' });
    }

    const vehicleCountRow = this.renderRow(
      'au.entity.group.vehicleMemberCount',
      vehicleCountValue,
      'vehicle_count_row'
    );
    rows.push(vehicleCountRow);

    // create device member count row
    let deviceCountValue;
    if (fetchingMemberCount) {
      deviceCountValue = <LoadingIndicator display={true} />;
    } else if (memberCountError) {
      deviceCountValue = formatMessage({ id: 'au.entity.group.memberCount.error' });
    } else if (deviceCount !== null) {
      deviceCountValue = deviceCount.toLocaleString();
    } else {
      deviceCountValue = formatMessage({ id: 'au.entity.group.memberCount.unavailable' });
    }

    const deviceCountRow = this.renderRow(
      'au.entity.group.deviceMemberCount',
      deviceCountValue,
      'device_count_row'
    );
    rows.push(deviceCountRow);

    return rows;
  }

}